import { createAction, props } from '@ngrx/store';

import { IFormMode } from '../../types/IFormMode';
import { Endpoint } from '../../../core/domain/endpoint/endpoint';

export const openEndpointModal = createAction(
  '[Endpoint Modal] Open Modal',
  props<{ mode: IFormMode; endpoint?: Endpoint; providerId: string }>()
);

export const closeEndpointModal = createAction('[Endpoint Modal] Close Modal');
